var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrategy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3495 4.78878H27.6352C28.3929 4.78878 29.1198 5.08981 29.6555 5.62561C30.1912 6.16144 30.4923 6.88815 30.4923 7.64593V36.2174C30.4923 36.9751 30.1912 37.7019 29.6555 38.2376C29.1198 38.7734 28.3929 39.0745 27.6352 39.0745H4.77804C4.02027 39.0745 3.29356 38.7734 2.75773 38.2376C2.22193 37.7019 1.9209 36.9751 1.9209 36.2174V7.64593C1.9209 6.88815 2.22193 6.16144 2.75773 5.62561C3.29356 5.08981 4.02027 4.78878 4.77804 4.78878H9.06376M23.3495 4.78878V6.21736C23.3495 7.7953 22.0703 9.0745 20.4923 9.0745H11.9209C10.343 9.0745 9.06376 7.7953 9.06376 6.21736V4.78878M23.3495 4.78878C23.3495 3.21083 22.0703 1.93164 20.4923 1.93164H11.9209C10.343 1.93164 9.06376 3.21083 9.06376 4.78878M17.4985 25.7395L24.6413 32.8825M24.646 25.7395L17.5032 32.8825M7.76633 18.2263C7.76633 20.1987 9.3653 21.7977 11.3378 21.7977C11.8364 21.7977 12.3112 21.6955 12.7423 21.5109C14.0165 20.9654 14.9092 19.7001 14.9092 18.2263C14.9092 16.2538 13.3102 14.6548 11.3378 14.6548C9.3653 14.6548 7.76633 16.2538 7.76633 18.2263Z",
    stroke: "#0E9349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrategy);
export default __webpack_public_path__ + "static/media/iconStrategy.dac0aabce587936dd911801517d25942.svg";
export { ForwardRef as ReactComponent };